import { configureStore } from '@reduxjs/toolkit'
import purchasesOrdersReducer from './slices/purchasesOrdersSlice'
import paymentReducer from './slices/paymentsSlice'
import inventoryReducer from './slices/inventorySlice'
import productCostReducer from './slices/productCostSlice'
import productsReducer from './slices/productsSlice'
import ddpReducer from './slices/ddpSlice'
import edtReducer from './slices/edtSlice'
import profitAndLossNewReducer from './slices/quickbooks/profitAndLossNewSlice'
import usersSettingsReducer from './slices/managementSlices/usersSettingsSlice'
import productGroupReducer from './slices/productGroupSlice'
import productCategoriesReducer from './slices/productCategoriesSlice'
import reportsReducer from './slices/reportsSlice'
import mailReducer from './slices/mailSlice'
import boxReceivedReducer from './slices/boxReceivedSlice'
import reportSendHistoryReducer from './slices/reportSendHistory'
import reportSheetSyncReducer from './slices/reportSheetSync'
import instructionsReducer from './slices/instructionsSlice'
import authReducer from './slices/authSlice'
import forecastReducer from './slices/quickbooks/forecastSlice'
import forecastPlanningReducer from './slices/quickbooks/forecastPlanningSlice'
import materialSpecificationsReducer from './slices/materialSpecificationsSlice'
import vendorsReducer from './slices/managementSlices/vendorsSlice'
import cashFlowReducer from './slices/quickbooks/cashFlowSlice'
import cogsPreviewReducer from './slices/cogsPreviewSlice'
import quickBooksReducer from './slices/quickBooksSlice';
import balanceSheetReducer from './slices/quickbooks/balanceSheetSlice';
import reportEmailSettingsReducer from './slices/reportEmailSettings';
import customReportsReducer from './slices/customReports';
import cronReducer from './slices/cronSlice'
import budgetReducer from './slices/quickbooks/budgetSlice'
import openToBuyReducer from './slices/quickbooks/openToBuySlice'
import reportCategories from './slices/quickbooks/reportCategories'
import budgetLineItemsReducer from './slices/quickbooks/budgetLineItemSlice'
import moqReducer from './slices/moqSlice'
import notificationsReducer from './slices/managementSlices/notificationsSlice'
import shipmentsReducer from './slices/shippingSlice'
import categoriesReducer from './slices/categoriesSlice'
import billOfMaterialsReducer from './slices/billOfMaterialsSlice'
import purchaseOrdersReducer from './slices/managementSlices/purchaseOrdersSlice'
import tripleWhaleReducer from './slices/tripleWhaleSlice'
import demandPlanningReducer from './slices/demandPlanningSlice'
import tripleWhaleSettingsReducer from './slices/tripleWhaleSettingsSlice'
import forecastSettingsReducer from './slices/forecastSettingsSlice'
import profitAndLossTotalNamesReducer from './slices/profitAndLossTotalNamesSlice'
import productCatalogReducer from './slices/productCatalogSlice'
import inventorySkuMappingReducer from './slices/inventorySkuMappingSlice'
import bomUiReducer from './slices/bomUiSlice'
import thirteenWeekCashFlowReducer from './slices/finance/thirteenWeekCashFlowSlice'

export const reducer = {
    payments: paymentReducer,
    purchasesOrders: purchasesOrdersReducer,
    productCosts: productCostReducer,
    vendors: vendorsReducer,
    moq: moqReducer,
    budget: budgetReducer,
    forecastPlanning: forecastPlanningReducer,
    ddp: ddpReducer,
    notifications: notificationsReducer,
    forecast: forecastReducer,
    balanceSheet: balanceSheetReducer,
    openToBuy: openToBuyReducer,
    cashFlow: cashFlowReducer,
    budgetLineItem: budgetLineItemsReducer,
    reportCategories: reportCategories,
    productGroup: productGroupReducer,
    profitAndLossNew: profitAndLossNewReducer,
    productCatalog: productCatalogReducer,
    products: productsReducer,
    shipments: shipmentsReducer,
    reports: reportsReducer,
    demandPlanning: demandPlanningReducer,
    reportEmailSettings: reportEmailSettingsReducer,
    customReports: customReportsReducer,
    productCategories: productCategoriesReducer,
    reportSendHistory: reportSendHistoryReducer,
    reportSheetSync: reportSheetSyncReducer,
    instructions: instructionsReducer,
    inventory: inventoryReducer,
    auth: authReducer,
    usersSettings: usersSettingsReducer,
    mail: mailReducer,
    edt: edtReducer,
    materialSpecifications: materialSpecificationsReducer,
    quickBooks: quickBooksReducer,
    cron: cronReducer,
    categories: categoriesReducer,
    billOfMaterials: billOfMaterialsReducer,
    purchaseOrdersManagement: purchaseOrdersReducer,
    tripleWhale: tripleWhaleReducer,
    tripleWhaleSettings: tripleWhaleSettingsReducer,
    forecastSettings: forecastSettingsReducer,
    profitAndLossTotalNames: profitAndLossTotalNamesReducer,
    inventorySkuMapping: inventorySkuMappingReducer,
    bomUi: bomUiReducer,
    cogsPreview: cogsPreviewReducer,
    boxReceived: boxReceivedReducer,
    thirteenWeekCashFlow: thirteenWeekCashFlowReducer,
}
  
export const store = configureStore({
    reducer
})